// extracted by mini-css-extract-plugin
export default {"container":"gk1Nw"};